export const canCaptureLead = (lead, user, older = null) => {
  // lead suspensa, nao renderiza
  if (lead?.suspended_lead) return false;
  // lead state diferente de 1, nao renderiza
  if (lead.state != 1) return false;

  // user role menor ou igual a 2, renderiza
  if (user.role <= 2) return true;

  // se tiver broker_id e broker_id != user id, nao  renderiza
  if (lead.broker_id && lead.broker_id != user.id) return false;

  // se nao tiver dentro do array e lead id diferente de older e lead broker id for nulo, nao renderiza
  if (![7, 8, 9, 10, 14, 27, 28, 29].includes(lead.channel_id) && lead.id != older && lead.broker_id == null) {
    if (older == null && lead.broker_id == null) return true;

    if (lead?.id != older && lead?.broker_id == null) return false;
  }

  return true;
};
